module.exports = __webpack_public_path__ + "img/local_gas_station.d33c0660.svg";